import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import noop from 'utils/noop';
import { NavigateState, PageState } from '../types';

export type QuickActionsMenuContextState = {
  /** util function to reset menu page, search and value properties */
  closeMenu: () => void;
  /** search term converted to lower case to use when searching and filtering */
  debouncedSearchTerm: string;
  /** util function to close menu and navigate to a page within the app */
  navigate: (state: NavigateState) => void;
  pageState: PageState | null;
  searchTerm: string;
  /** util function to select page and reset state */
  selectPage: (page: PageState) => void;
  setSearchTerm: (searchTerm: string) => void;
  /** util function to set controlled value for command root */
  setValue: Dispatch<SetStateAction<string>>;
  value: string;
};

export const defaultQuickActionsMenuState = {
  closeMenu: noop,
  debouncedSearchTerm: '',
  navigate: noop,
  pageState: null,
  searchTerm: '',
  selectPage: noop,
  setSearchTerm: noop,
  setValue: noop,
  value: '',
};

export const QuickActionsMenuContext = createContext<QuickActionsMenuContextState>(
  defaultQuickActionsMenuState,
);

export const useQuickActionsMenuContext = () => useContext(QuickActionsMenuContext);
